
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter bulk order details:</p>
      </div>
    </div>
  </div>
  <div class="form" [formGroup]="bulkOrder.form">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="form-group col">
            <label class="required" for="orderName">Name:</label>
            <input class="form-control" id="orderName" formControlName="name" maxlength="100" required>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label class="required" for="orderDeliveryMethod">Delivery Method</label>
            <select class="form-control" id="orderDeliveryMethod" formControlName="deliveryMethod" required>
              <option *ngFor="let property of deliveryMethodValues" [value]="property[0]">{{property[1]}}</option>
              <option value=""></option>
            </select>
          </div>
          <div class="col-lg-6">
            <div class="inline-block">
              <label for="requestedDeliveryDateText">Customer Requested Delivery Date (CRDD in S4)</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="requestedDeliveryDateText" formControlName="requestedDeliveryDate" type="text" [value]="bulkOrder.form.value.requestedDeliveryDate">
              <datepicker class="right input-group-append" formControlName="requestedDeliveryDate" [value]="bulkOrder.form.value.requestedDeliveryDate"></datepicker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <label class="control-label" for="orderDeliveryInformation">Delivery Information</label>
            <textarea class="form-control" id="orderDeliveryInformation" formControlName="deliveryInformation" maxlength="300"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>